import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Form, Input, Button } from 'antd'
import { saveSettings } from './actions'

const FormItem = Form.Item

const mapStateToProps = (state) => {
    return {
        settings: state.settings
    }
}

@Form.create()
@connect(mapStateToProps, {saveSettings})
class Settings extends Component {

    updateSettings = () => {
        const { form, onCancel } = this.props

        form.validateFields((error, values) => {
            if (!error) {
                this.props.saveSettings(values)
                onCancel()
            }
        },
        )
    }

    render() {

        const { form, settings } = this.props
        const { apiKey, contractCode } = settings
        return (
            <div>
                <div className="col-md-12">
                    <FormItem label="Api Key">
                        {form.getFieldDecorator('apiKey', {
                            validateFirst: true,
                            initialValue: apiKey,
                            rules: [{ required: true, message: 'Please enter your api key' }],
                        })(
                            <Input size="large" size="large" placeholder="Api Key" />,
                        )}
                    </FormItem>
                </div>

                <div className="col-md-12">
                    <FormItem label="Contract Code">
                        {form.getFieldDecorator('contractCode', {
                            validateFirst: true,
                            initialValue: contractCode,
                            rules: [{ required: true, message: 'Please enter your contract code' }],
                        })(
                            <Input size="large" size="large" placeholder="Contract Code" />,
                        )}
                    </FormItem>
                </div>

                <div className="col-md-2">
                    <Button type="primary" onClick={this.updateSettings}>Save</Button>
                </div>

            </div>)
    }
}
export default Settings


// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/Settings/index.js